/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.SummarizationRpc
 */

export const summarizeVideoRpc = {
  serviceName: 'com.hubspot.academy.gen.ai.skills.rpc.SummarizationRpc',
  rpcName: 'summarizeVideo',
  auth: 'app',
  fingerprint: '9SjTdnCCSummo2LCGj3P58Ve2UWRC0f9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const asyncBulkGenerateVideoSummaryRpc = {
  serviceName: 'com.hubspot.academy.gen.ai.skills.rpc.SummarizationRpc',
  rpcName: 'asyncBulkGenerateVideoSummary',
  auth: 'app',
  fingerprint: 'NjHjafHZmpYtCiYZzFQj2cVe2UWRC0f9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const asyncBulkGetVideoSummaryRpc = {
  serviceName: 'com.hubspot.academy.gen.ai.skills.rpc.SummarizationRpc',
  rpcName: 'asyncBulkGetVideoSummary',
  auth: 'app',
  fingerprint: 'KPKpB0XPIyU9MEkPaKYuxMVe2UWRC0f9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};